import { svgToDataUrl } from './utils/svgToDataUrl';

export const SPRITE_ICON_BASE_URL = 'https://t1.kakaocdn.net/kic_console';

export const SKELETON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <mask id="a" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse">
    <path fill="#6b7280" d="M0 0h24v24H0z"/>
  </mask>
  <g mask="url(#a)">
    <path fill="#6b7280" fill-rule="evenodd" d="M11.497 5.4a5.284 5.284 0 0 0-5.274 4.956l-.035.576-.566.114a3.893 3.893 0 0 0 .77 7.707H17.53a3.891 3.891 0 1 0 0-7.783h-.713l-.053-.693A5.284 5.284 0 0 0 11.497 5.4ZM4.782 9.714a6.785 6.785 0 0 1 13.397-.206 5.392 5.392 0 0 1-.648 10.745H6.391a5.391 5.391 0 0 1-1.61-10.539Z" clip-rule="evenodd" opacity="1"/>
  </g>
</svg>`;

export const INITIAL_FALLBACK_ICON_DATA_URL = svgToDataUrl(SKELETON_SVG);
